import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { InputText } from 'primereact/inputtext';
import usePropertiesUi from '../../hooks/usePropertiesUi';

export default function PropertiesSearchInput() {
  const {
    propertiesView: { searchValue },
    setPropertiesView,
  } = usePropertiesUi();

  return (
    <IconField iconPosition='left'>
      {searchValue !== '' ? (
        <InputIcon className='pi pi-times' onClick={() => setPropertiesView({ searchValue: '' })}></InputIcon>
      ) : (
        <InputIcon className='pi pi-search'></InputIcon>
      )}
      <InputText
        className='p-inputtext-md !w-[12rem]'
        placeholder='Search Properties'
        type='text'
        value={searchValue}
        onChange={(e) => setPropertiesView({ searchValue: e.target.value })}
      />
    </IconField>
  );
}
